import { c as _c } from "react/compiler-runtime";
import { useContext } from 'react';
import useSWR from 'swr';
import APIMethodKeys from '../../../../client/APIMethodKeys';
import Button from '../../../common/base/Button';
import { GlobalContext } from '../../../contexts/GlobalContext';
import { StyledViewNavHeader, StyledViewSidebar, StyledViewSidebarActions, StyledViewSidebarNav, StyledViewSidebarScrollableSection, ViewSidebarTitle } from '../../../layouts/ViewLayout';
import EventSidebar from '../Events/EventSidebar';
import IgnoredEventSidebarSection from './IgnoredEventSidebarSection';
import Loading from '../../../common/base/Loading';
import { Div } from '../../../common/helpers/StyledUtils';
const EntrySidebar: React.FC<{
  request_id: string;
  entry_id: string;
  onClose: () => void;
  retry: (request_id: string, webhook_ids: string[]) => void;
}> = t0 => {
  const $ = _c(36);
  const {
    request_id,
    entry_id,
    onClose,
    retry
  } = t0;
  const {
    HookdeckAPI
  } = useContext(GlobalContext);
  let t1;
  if ($[0] !== entry_id) {
    t1 = entry_id.startsWith("evt_");
    $[0] = entry_id;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const is_event = t1;
  let t2;
  if ($[2] !== entry_id || $[3] !== is_event || $[4] !== request_id) {
    t2 = !is_event && APIMethodKeys.requests.listIgnoredEvents(request_id, {
      id: entry_id,
      limit: 1
    });
    $[2] = entry_id;
    $[3] = is_event;
    $[4] = request_id;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== HookdeckAPI.requests || $[7] !== entry_id || $[8] !== request_id) {
    t3 = () => HookdeckAPI.requests.listIgnoredEvents(request_id, {
      id: entry_id,
      limit: 1
    });
    $[6] = HookdeckAPI.requests;
    $[7] = entry_id;
    $[8] = request_id;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  const {
    data: ignored_events
  } = useSWR(t2, t3);
  if (is_event) {
    let t4;
    if ($[10] !== entry_id || $[11] !== onClose) {
      t4 = <EventSidebar event_id={entry_id} onClose={onClose} onSelectedAttempt={_temp} />;
      $[10] = entry_id;
      $[11] = onClose;
      $[12] = t4;
    } else {
      t4 = $[12];
    }
    return t4;
  }
  const ignored_event = ignored_events?.models[0];
  let t4;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <ViewSidebarTitle title="Ignored event" />;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  const t5 = !ignored_event;
  let t6;
  if ($[14] !== ignored_event || $[15] !== request_id || $[16] !== retry) {
    t6 = () => ignored_event && retry(request_id, [ignored_event.webhook_id]);
    $[14] = ignored_event;
    $[15] = request_id;
    $[16] = retry;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  let t7;
  if ($[18] !== t5 || $[19] !== t6) {
    t7 = <Button.Permission role="member" ghost={true} title="Retry" icon="retry" disabled={t5} onClick={t6} />;
    $[18] = t5;
    $[19] = t6;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  let t8;
  if ($[21] !== onClose) {
    t8 = <Button ghost={true} icon="close" onClick={onClose} />;
    $[21] = onClose;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  let t9;
  if ($[23] !== t7 || $[24] !== t8) {
    t9 = <StyledViewSidebarNav><StyledViewNavHeader>{t4}<StyledViewSidebarActions>{t7}{t8}</StyledViewSidebarActions></StyledViewNavHeader></StyledViewSidebarNav>;
    $[23] = t7;
    $[24] = t8;
    $[25] = t9;
  } else {
    t9 = $[25];
  }
  let t10;
  if ($[26] !== ignored_event) {
    t10 = [ignored_event];
    $[26] = ignored_event;
    $[27] = t10;
  } else {
    t10 = $[27];
  }
  let t11;
  if ($[28] !== ignored_event) {
    t11 = () => <StyledViewSidebarScrollableSection><IgnoredEventSidebarSection ignored_event={ignored_event} /></StyledViewSidebarScrollableSection>;
    $[28] = ignored_event;
    $[29] = t11;
  } else {
    t11 = $[29];
  }
  let t12;
  if ($[30] !== t10 || $[31] !== t11) {
    t12 = <Loading require={t10} wrapper={_temp2}>{t11}</Loading>;
    $[30] = t10;
    $[31] = t11;
    $[32] = t12;
  } else {
    t12 = $[32];
  }
  let t13;
  if ($[33] !== t12 || $[34] !== t9) {
    t13 = <StyledViewSidebar>{t9}{t12}</StyledViewSidebar>;
    $[33] = t12;
    $[34] = t9;
    $[35] = t13;
  } else {
    t13 = $[35];
  }
  return t13;
};
export default EntrySidebar;
function _temp() {}
function _temp2() {
  return <Div flex={{
    grow: true,
    align: "center",
    justify: "center"
  }}><Loading /></Div>;
}